import { render, staticRenderFns } from "./BreederStatistics.vue?vue&type=template&id=0d465268&scoped=true"
import script from "./BreederStatistics.vue?vue&type=script&lang=js"
export * from "./BreederStatistics.vue?vue&type=script&lang=js"
import style0 from "./BreederStatistics.vue?vue&type=style&index=0&id=0d465268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d465268",
  null
  
)

export default component.exports